/**
 * Append Supabase Storage image transformation params to reduce download size
 * for images displayed at small dimensions. Falls back to the original URL for
 * non-Supabase or non-public-object URLs.
 *
 * Supabase render endpoint: /storage/v1/render/image/public/...
 * We rewrite /object/public/ -> /render/image/public/ and add width/quality.
 */
export function transformSupabaseImage(
  url: string | undefined | null,
  opts: { width?: number; height?: number; quality?: number; resize?: "cover" | "contain" } = {}
): string {
  if (!url) return url || "";
  try {
    // Only transform Supabase public storage URLs we recognize.
    if (!url.includes("/storage/v1/object/public/")) return url;
    // Skip videos / non-image types — only safe for raster images.
    if (/\.(mp4|webm|mov|m4v)(\?|$)/i.test(url)) return url;

    const rendered = url.replace("/storage/v1/object/public/", "/storage/v1/render/image/public/");
    const u = new URL(rendered);
    if (opts.width) u.searchParams.set("width", String(Math.round(opts.width)));
    if (opts.height) u.searchParams.set("height", String(Math.round(opts.height)));
    u.searchParams.set("quality", String(opts.quality ?? 75));
    u.searchParams.set("resize", opts.resize ?? "contain");
    return u.toString();
  } catch {
    return url;
  }
}
